import React from "react";
import { subscribeToContextChange } from "@platform/core";

export interface ValidContext {
  loan: boolean;
  workItem: boolean;
}

// todo: this should probably be in core

export function useValidContexts() {
  const [validContexts, setValidContexts] = React.useState<ValidContext>({
    loan: false,
    workItem: false,
  });

  React.useEffect(() => {
    const loanContext = subscribeToContextChange("loan", {
      onSet: () => {
        setValidContexts((current) => ({ ...current, loan: true }));
      },
      onUnset: () => {
        setValidContexts((current) => ({ ...current, loan: false }));
      },
    });
    const workItemContext = subscribeToContextChange("workItem", {
      onSet: () => {
        setValidContexts((current) => ({ ...current, workItem: true }));
      },
      onUnset: () => {
        setValidContexts((current) => ({ ...current, workItem: false }));
      },
    });

    return () => {
      loanContext.unsubscribe();
      workItemContext.unsubscribe();
    };
  }, []);

  return validContexts;
}
